module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedThin.385a2ac.woff2";